import CAP1 from "./data/cap1";
import CAP2 from "./data/cap2";
import CAP3 from "./data/cap3";
import CAP4 from "./data/cap4";
import CAP5 from "./data/cap5";
import CAP6 from "./data/cap6";
import CAP7 from "./data/cap7";
import CAP8 from "./data/cap8";
import CAP9 from "./data/cap9";
import CAP10 from "./data/cap10";
import CAP11 from "./data/cap11";
import CAP12 from "./data/cap12";
import CAP13 from "./data/cap13";
import CAP14 from "./data/cap14";
import CAP15 from "./data/cap15";
import CAP16 from "./data/cap16";
import CAP17 from "./data/cap17";
import CAP18 from "./data/cap18";
import CAP19 from "./data/cap19";
import CAP20 from "./data/cap20";
import CAP21 from "./data/cap21";
import CAP22 from "./data/cap22";
import CAP23 from "./data/cap23";
import CAP24 from "./data/cap24";
import CAP25 from "./data/cap25";

export const BLOCKCHAIN_FUNDAMENTALS_CAPS = {
  cap1: CAP1,
  cap2: CAP2,
  cap3: CAP3,
  cap4: CAP4,
  cap5: CAP5,
  cap6: CAP6,
  cap7: CAP7,
  cap8: CAP8,
  cap9: CAP9,
  cap10: CAP10,
  cap11: CAP11,
  cap12: CAP12,
  cap13: CAP13,
  cap14: CAP14,
  cap15: CAP15,
  cap16: CAP16,
  cap17: CAP17,
  cap18: CAP18,
  cap19: CAP19,
  cap20: CAP20,
  cap21: CAP21,
  cap22: CAP22,
  cap23: CAP23,
  cap24: CAP24,
  cap25: CAP25
};
